<template>
  <div class="row p-3 m-0 rounded-lg" :style="backgroundStyle(level)">
    <template v-for="(value, key) in data">
      <template v-if="isRenderEmpty || !isEmpty(value)">
        <div v-if="isArrayOfObjectsField(value)" class="col-12 p-0 m-0">
          <div class="font-weight-bold" :style="fontSizeStyle(level)">
            {{ vocabulary[key] || camelize(key) }}:
          </div>
          <div class="p-3 m-0 d-flex flex-column border-left" :style="{ gap: '1rem' }">
            <template v-for="_value in value">
              <Recursion :data="_value" :vocabulary="vocabulary" :isRenderEmpty="isRenderEmpty" :level="level + 1" />
            </template>
          </div>
        </div>
        <div v-else-if="isObjectField(value)" class="col-12 p-0 mb-3">
          <div class="font-weight-bold" :style="fontSizeStyle(level + 2)">
            {{ vocabulary[key] || camelize(key) }}:
          </div>
          <Recursion :data="value" :vocabulary="vocabulary" :isRenderEmpty="isRenderEmpty" :level="level + 1" />
        </div>
        <div v-else-if="isArrayOfStringsField(value)" :class="['col-6 p-0 m-0', getSpecialClasses(key)]">
          <div class="font-weight-bold">{{ vocabulary[key] || camelize(key) }}:</div>
          <div class="pl-2">
            <div v-for="val in value">&#x2022; {{ transformValue(val) }}</div>
          </div>
        </div>
        <div v-else :class="['col-6 p-0 m-0', getSpecialClasses(key)]">
          <span class="font-weight-bold">{{ vocabulary[key] || camelize(key) }}:</span> {{ transformValue(value) }}
        </div>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: "Recursion",
  components: {},
  props: ["data", "vocabulary", "level", "isRenderEmpty", "specialClasses"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // Styling methods based on level
    backgroundStyle(level) {
      const currentColor = `rgb(${255 - (level * 15)}, ${255 - (level * 15)}, ${255 - (level * 15)})`;
      return {
        backgroundColor: currentColor,
      };
    },
    fontSizeStyle(level = 0) {
      return {
        fontSize: `${16 + 12 - level * 2}px`,
      };
    },
    transformValue(value) {
      switch (true) {
        case value === null:
        case Array.isArray(value) && value.length === 0:
          return "";
        case value === false:
        case value === "0":
          return this.$t("message.no");
        case value === true:
        case value === "1":
          return this.$t("message.yes");
        default:
          return value;
      }
    },
    // Other methods
    getSpecialClasses(key) {
      return (this.specialClasses && this.specialClasses[key]) || "";
    },
    camelize(str) {
      let result = "";
      for (let i = 0; i < str.length; i++) {
        if (i === 0) {
          result += str[i].toUpperCase();
        } else if (str[i] === str[i].toUpperCase()) {
          result += " " + str[i];
        } else {
          result += str[i];
        }
      }
      return result;
    },
    isEmpty(val) {
      return [undefined, null, ""].includes(val) || (typeof val === "object" && Object.keys(val).length === 0);
    },
    isArrayOfObjectsField(val) {
      return Array.isArray(val) && val.length > 0 && typeof val[0] === "object";
    },
    isObjectField(val) {
      return typeof val === "object" && !Array.isArray(val);
    },
    isArrayOfStringsField(val) {
      return Array.isArray(val) && val.length > 0 && typeof val[0] === "string";
    },
  },
  computed: {},
  watch: {},
};
</script>
<style></style>